class SearchModal extends DetailsModal {
  constructor() {
    super();
  }

  open(event) {
    window.loadScript(this.dataset.src, () => {
      document.dispatchEvent(new CustomEvent('load_search'));
    });
    super.open(event);
    this.detailsContainer.addEventListener('transitionend', () => {
      this.detailsContainer.querySelector('input:not([type="hidden"])').focus()
    }, { once: true });
  }
}

customElements.define("search-modal", SearchModal);
